export const FONT_SIZE = 12;
export const BAR_BORDER_RADIUS = 4;

export const MARGIN = {
  top: 8 + FONT_SIZE / 2,
  right: 0,
  bottom: 28,
  left: 0,
};

export const WRAPPER = {
  width: window.innerWidth,
  height: 282,
};

export const WIDTH = WRAPPER.width - MARGIN.left - MARGIN.right;
export const HEIGHT = WRAPPER.height - MARGIN.top - MARGIN.bottom;
